define('StellarGrade.ST_Facets.Main', [
    'StellarGrade.ST_Facets.Facets.View',
    'StellarGrade.ST_Facets.Tooltip.View',
    'StellarGrade.ST_Facets.FacetsBrowseCategoryCell.View',
    'StellarGrade.ST_Facets.FacetsBrowseCategoryHeading.View',
    'StellarGrade.ST_Facets.Facets.Browse.View',

], function (
    FacetView, TooltipView, FacetsBrowseCategoryCellView, 
    FacetsBrowseCategoryHeadingView,  FacetsBrowseView
    ) {
    'use strict';

    return {
        mountToApp: function (container) {
            FacetView.loadModule(container);
            TooltipView.loadModule(container);
            FacetsBrowseCategoryCellView.loadModule(container);
            FacetsBrowseCategoryHeadingView.loadModule(container);
            FacetsBrowseView.loadModule(container);
        },
    };
});
